<template>
    <div class="root">
        <!-- <LMap v-bind="mapOptions">
            <LTileLayer v-bind="tileLayerOptions" />
            <LRoutingMachine v-bind="routingOptions" @routingstart="debugRoutingEvent" @routesfound="debugRoutingEvent"
                @routingerror="debugRoutingEvent" />
        </LMap> -->
        <l-map ref="map" :zoom="zoom" :center="centerValue">
            <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base" name="OpenStreetMap"></l-tile-layer>
            <l-marker :lat-lng="LatLngFirst" :icon="iconFrom"></l-marker>
            <!-- <l-marker :latLng="latLngSecond" :icon="iconTo"></l-marker> -->
            <!-- <l-polyline :color="'green'" :lat-lngs="latLngs" /> -->
            <LRoutingMachine v-bind="routingOptions" @routingstart="debugRoutingEvent" @routesfound="debugRoutingEvent"
                @routingerror="debugRoutingEvent" />
        </l-map>
        
    </div>
</template>

<script>
import { reactive } from "vue";
import { LMap, LTileLayer } from "@vue-leaflet/vue-leaflet";
import LRoutingMachine from "@/components/LRoutingMachine.vue";
import "leaflet/dist/leaflet.css";

export default {
    props: ['LatLngFirst', 'latLngSecond', 'latLngs', 'centerValue'],

    components: {
        LMap,
        LTileLayer,
        LRoutingMachine,
    },
    setup(props) {
        const mapOptions = {
            center: props.centerValue,
            zoom: 4,
        };
        const tileLayerOptions = {
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            continuousWorld: false,
            noWrap: true,
        };
        const routingOptions = reactive({
            waypoints: [
                props.LatLngFirst,
                props.latLngSecond,
            ],
            altLineOptions: {
		styles: [
			{color: 'black', opacity: 0.15, weight: 9},
			{color: 'white', opacity: 0.8, weight: 6},
			{color: 'blue', opacity: 0.5, weight: 2}
		]
	}
        });

        const debugRoutingEvent = (event) => {
            // console.log(`${event.type} event: `, event);
        };

        return {
            mapOptions,
            tileLayerOptions,
            routingOptions,
            debugRoutingEvent,
        };
    },
};
</script>

<style scoped>
.leaflet-container {
    z-index: 0 !important;
}

.root {
    height: 128px;
}
</style>